export default "__VITE_ASSET__CB4FDNjh__"